import axios from 'axios'
import generalHeader from '../../utils/constants/generalHeader'
import { API_ORIGIN } from '../../utils/constants/url'
import { CLIENT_TYPE_HEADER } from '../../utils/constants/ClientTypeHeader'

export const googleLogin = async (data) => {
  const url = `${API_ORIGIN}/v1/auth/google`

  const response = await axios.post(
    url,
    { googleUserCredentials: data.credential, platform: CLIENT_TYPE_HEADER },
    {
      headers: generalHeader(),
      withCredentials: true,
    },
  )
  if (response.status !== 200) throw new Error(response.status)
  return response.data
}
